// Add the Gmail address(es) allowed into /admin here
export const ADMIN_EMAILS = [
  "rammandirraipur@gmail.com",
];